import { render, staticRenderFns } from "./FaqFilterModal.vue?vue&type=template&id=2d3e87a8&scoped=true"
import script from "./FaqFilterModal.vue?vue&type=script&lang=js"
export * from "./FaqFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e87a8",
  null
  
)

export default component.exports